import { useEffect, Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var DocumentTitle = props => {
  useEffect(() => {
    if (props.title && document) {
      var dom = document.querySelector('title');
      if (dom) {
        dom.innerHTML = props.title || '';
      }
    }
  }, [props.title]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: props.children
  });
};